
import Container from "../../components/Container";
import FullContent from "../../components/FullContent";
import HalfAndHalf from "../../components/HalfAndHalf";
import { serviceObject } from "../../providers/GlobalObjects";

const ServiceClient = ({slug}) => {

    // const service =  serviceObject.find(item => item.slug === slug);
    // console.log(service);
    const description = 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Facilis dolor, harum labore, animi alias velit itaque consequatur dolorem enim distinctio odit quasi, pariatur aperiam possimus impedit quibusdam. Ipsam, asperiores eaque?'
    
    return (
        <section className="bg-secondary-black">
            <Container className="py-5">
                <FullContent 
                    heading={'Lorem ipsum, dolor'}
                    description={description}
                    buttonObject={''}
                />

                <HalfAndHalf 
                    className="py-5"
                    heading={'Lorem ipsum, dolor'}
                    description={description}
                    image={'https://placehold.co/1000x1000/jpg'}
                />
            </Container>
        </section>
    );
};

export default ServiceClient;